import type {GetReportList} from './types'

// @ts-ignore
import {HEALTH_AND_WELFARE_PENSION} from 'procedureStatuses/reportList/common'

export const getReportList: GetReportList = function* ({healthInsuranceJoined, healthInsuranceType}) {
  if (healthInsuranceJoined) {
    if (healthInsuranceType === 'kyokai' || healthInsuranceType === 'other') {
      yield {
        num: 'r9',
        title: '健康保険 資格確認書交付申請書',
        editable: true,
        type: HEALTH_AND_WELFARE_PENSION,
      }
    } else if (healthInsuranceType === 'its') {
      yield {
        num: 'r10',
        title: '健康保険 資格確認書（再）交付申請書',
        editable: true,
        type: HEALTH_AND_WELFARE_PENSION,
      }
    }
  }
}

const ProcedureInfo = () => null

export default {getReportList, ProcedureInfo}
